import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/leviia/logo-sm.svg")